import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "size", "target", "type", "appearance", "tabIndex", "fullWidth"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import cn from 'classnames';
import { forwardRef } from 'react';
import { extractSupportProps } from '@sbercloud/uikit-product-utils';
import { APPEARANCE, HTML_TYPE, SIZE, TARGET } from '../../constants';
import { ButtonPrivate } from '../../helperComponents';
import { extractCommonButtonProps } from '../../utils';
import styles from "./styles.module.css";
import { jsx as _jsx } from "react/jsx-runtime";
export var ButtonPromo = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var className = _ref.className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? SIZE.S : _ref$size,
    _ref$target = _ref.target,
    target = _ref$target === void 0 ? TARGET.Blank : _ref$target,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? HTML_TYPE.Button : _ref$type,
    _ref$appearance = _ref.appearance,
    appearance = _ref$appearance === void 0 ? APPEARANCE.Tertiary : _ref$appearance,
    tabIndex = _ref.tabIndex,
    _ref$fullWidth = _ref.fullWidth,
    fullWidth = _ref$fullWidth === void 0 ? false : _ref$fullWidth,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsx(ButtonPrivate, _objectSpread(_objectSpread(_objectSpread({}, extractSupportProps(rest)), extractCommonButtonProps(rest)), {}, {
    className: cn(styles.button, className),
    iconClassName: styles.icon,
    labelClassName: styles.label,
    size: size,
    fullWidth: fullWidth,
    target: target,
    type: type,
    appearance: appearance,
    tabIndex: tabIndex,
    ref: ref
  }));
});